/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendActualMaterialDto } from '../../models/backend-actual-material-dto';
import { BackendActualMaterialRequestDto } from '../../models/backend-actual-material-request-dto';

export interface MonitoringActualsMaterialsCreate$FormData$Params {
  /**
   * ID сценария для фильтрации списка
   */
  scenario_id?: number;

  /**
   * Поиск по текстовым полям сущности
   */
  search?: string;
  body: BackendActualMaterialRequestDto;
}

export function monitoringActualsMaterialsCreate$FormData(
  http: HttpClient,
  rootUrl: string,
  params: MonitoringActualsMaterialsCreate$FormData$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendActualMaterialDto>> {
  const rb = new RequestBuilder(rootUrl, monitoringActualsMaterialsCreate$FormData.PATH, 'post');
  if (params) {
    rb.query('scenario_id', params.scenario_id, {});
    rb.query('search', params.search, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendActualMaterialDto>;
    }),
  );
}

monitoringActualsMaterialsCreate$FormData.PATH = '/api/monitoring/actuals/materials/';
